import { useSelector } from 'react-redux';
import { PointAdvertisingLayout } from '../../../../common/components';
import UpdateAdvertisingCampaign from '../../../common/advertising-campaign/UpdateAdvertisingCampaign';
import { getUser } from '../../../../common/store';

const AdminUpdateAdvertisingCampaign = () => {
    const user = useSelector(getUser);
    const orgId = user?.org?.id;

    return (
        <PointAdvertisingLayout title="Alterar campanha de publicidade">
            <UpdateAdvertisingCampaign orgId={orgId} />
        </PointAdvertisingLayout>
    );
};

export default AdminUpdateAdvertisingCampaign;
